module.exports = __webpack_public_path__ + "static/media/fedex.6666d825.svg";